import store from '@/store'
import axiosLib from 'axios'
import axiosConfigs from './config'

// Pega o axios do window
const axios = window.axios || axiosLib

const instance = axios.create(axiosConfigs)

instance.interceptors.request.use(
    config => {
        const state = store.getters['company/state']
        const company_id = state.company_id

        if (company_id)
            config.headers['Company-Id'] = company_id

        // Precisa que data seja um objeto para enviar o Content-Type        
        if (!config.data) {
            config.data = {}
        }

        return config
    },
    err => {
        return Promise.reject(err)
    }
)

window.axiosInstance = instance

export default instance